import { Injectable } from '@angular/core';
import { SharepointFolderDto } from "../../../../api/generated";

@Injectable({
  providedIn: 'root'
})
export class FolderService {

  constructor() { }

  public findFolderById(id: string, folders: SharepointFolderDto[]): SharepointFolderDto | null {
    if (!Array.isArray(folders)) {
      return null;
    }
    for (const folder of folders) {
      if (folder.id === id) {
        return folder;
      }
      const foundFolder = this.findFolderById(id, folder.subFolders);
      if (foundFolder !== null) {
        return foundFolder;
      }
    }
    return null;
  }

  public filterFoldersByName(searchQuery: string, folders: SharepointFolderDto[]): SharepointFolderDto[] {
    return folders.reduce((acc: SharepointFolderDto[], folder) => {
      // Check if the current folder matches the searchTerm
      if (folder.name.toLowerCase().includes(searchQuery.toLowerCase())) {
        acc.push(folder);
      } else if (folder.subFolders && folder.subFolders.length > 0) {
        // If the folder has subFolders, recursively filter them
        const filteredSubFolders = this.filterFoldersByName(searchQuery, folder.subFolders);
        if (filteredSubFolders.length > 0) {
          // If any subFolders match, include this folder in the result but only with the matching subFolders
          acc.push({ ...folder, subFolders: filteredSubFolders });
        }
      }
      return acc;
    }, []);
  }
}
